import React, { ReactNode } from 'react';
import _get from 'lodash/get';
import { useFormikContext } from 'formik';

import Toggle from '../form/Toggle';
import InfoTooltip from './InfoTooltip';
import classNames from 'classnames';

interface ToggleFieldProps {
  name: string;
  label: ReactNode;
  toolTipMessage?: string;
  labelClassName?: string;
}

const ToggleField: React.FC<ToggleFieldProps> = ({
  name,
  label,
  toolTipMessage,
  labelClassName
}) => {
  const { values, setFieldValue } = useFormikContext<any>();

  const toggle = () => {
    setFieldValue(name, !_get(values, name));
  };

  return (
    <div className="w-full text-sm font-normal text-gray-900 flex items-center justify-between">
      <div className={classNames('flex items-center', labelClassName)}>
        {label}

        {toolTipMessage && (
          <InfoTooltip id={`toggle-${name}-tooltip`} message={toolTipMessage} />
        )}
      </div>

      <Toggle isActive={_get(values, name)} onClick={toggle} />
    </div>
  );
};

export default ToggleField;
